import { MaintenanceFilter, MaintenanceFilterState } from '../../../types/maintenanceDetail'

/**
 * Transforms maintenance list UI filters into the backend AND-of-ORs format.
 */
export const buildMaintenanceFilters = (filterState: MaintenanceFilterState): MaintenanceFilter[][] => {
  const { searchString, searchField, statusFilter, priorityFilter, maintenanceType } = filterState
  const finalFilter: MaintenanceFilter[][] = []

  if (searchString) {
    if (searchField === 'request_address') {
      finalFilter.push([
        {
          field: 'company_address',
          type: 'string',
          operator: 'like',
          variable: searchString,
        },
        {
          field: 'specific_location',
          type: 'string',
          operator: 'like',
          variable: searchString,
        },
      ])
    } else if (searchField === 'public_id') {
      // Normalize common public ID input variations:
      // "RPHBZ 2602847" or "RPHBZ2602847" → "RPHBZ-2602847"
      const normalizedPublicId = searchString.trim().replace(/^([A-Za-z]+)\s*(\d+)$/, '$1-$2')
      finalFilter.push([
        {
          field: 'publicId',
          type: 'string',
          operator: 'like',
          variable: normalizedPublicId,
        },
      ])
    } else {
      finalFilter.push([
        {
          field: searchField || 'request_description',
          type: 'string',
          operator: 'like',
          variable: searchString,
        },
      ])
    }
  }

  if (statusFilter === -2) {
    finalFilter.push([
      {
        field: 'taskStatus',
        type: 'int',
        operator: '>=',
        variable: 0,
      },
    ])
  } else if (statusFilter > -1) {
    let operator: '=' | '!=' = '='
    let status = statusFilter

    if (statusFilter === 4) {
      operator = '!='
      status = 3
    }

    finalFilter.push([
      {
        field: 'taskStatus',
        type: 'int',
        operator,
        variable: status,
      },
    ])

    if (statusFilter === 4) {
      finalFilter.push([
        {
          field: 'request_priority',
          type: 'int',
          operator: '=',
          variable: 1,
        },
      ])
    }
  }

  if (priorityFilter && statusFilter !== 4) {
    finalFilter.push([
      {
        field: 'request_priority',
        type: 'int',
        operator: '=',
        variable: 1,
      },
    ])
  }

  if (maintenanceType) {
    const requestTypeMatch = String(maintenanceType).match(/^requestType-(\d+)$/)
    if (requestTypeMatch) {
      finalFilter.push([
        {
          field: 'request_type',
          type: 'int',
          operator: '=',
          variable: Number(requestTypeMatch[1]),
        },
      ])
    }
  }

  return finalFilter
}
